import { render, staticRenderFns } from "./SettingsTabSessions.vue?vue&type=template&id=2815d761&"
import script from "./SettingsTabSessions.vue?vue&type=script&lang=js&"
export * from "./SettingsTabSessions.vue?vue&type=script&lang=js&"
import style0 from "./SettingsTabSessions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports